var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Sidebar'),_c('div',{staticClass:"relative md:ml-64 bg-blueGray-100"},[_c('AdminNavbar'),_c('div',{staticClass:"px-4 md:px-10 mx-auto w-full -m-24"},[_c('router-view'),_c('AdminFooter')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }